<template>
  <div
    v-if="getOpenHouseEnabled && getOpenHouseDays.length > 0"
    :class="{
      'hmt-open-house': true,
      'hmt-open-house--expanded': expanded,
    }"
  >
    <div class="hmt-open-house__days">
      <div class="hmt-open-house__header">
        <button
          :class="{
            'hmt-open-house__header-btn': true,
            'hmt-open-house__header-btn--hide': expanded,
          }"
          @click="expand()"
        >
          &lsaquo;
        </button>
        <div>Open House</div>
        <button
          :class="{
            'hmt-open-house__header-btn': true,
            'hmt-open-house__header-btn--hide': !expanded,
          }"
          @click="collapse()"
        >
          &rsaquo;
        </button>
      </div>
      <div class="hmt-open-house__body">
        <div class="hmt-open-house__date">{{ new Date(getOpenHouseDays[activeDayIndex].day) | date('MMM dd') }}</div>
        <div class="hmt-open-house__time">
          {{ new Date(getOpenHouseDays[activeDayIndex].start) | date('h:mm a') }} -
          {{ new Date(getOpenHouseDays[activeDayIndex].end) | date('h:mm a') }}
        </div>
      </div>
      <div class="hmt-open-house__footer">
        <button
          v-if="activeDayIndex !== 0"
          type="button"
          class="hmt-open-house__paginate-btn"
          @click="prev"
        >
          &lsaquo; Prev
        </button>
        <button
          v-if="activeDayIndex < getOpenHouseDays.length - 1"
          type="button"
          class="hmt-open-house__paginate-btn"
          @click="next"
        >
          Next &rsaquo;
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dateFilter } from 'vue-date-fns';

export default {
  name: "HMTOpenHouse",
  filters: {
    date: dateFilter
  },
  data() {
    return {
      activeDayIndex: 0,
      expanded: true,
    };
  },
  computed: {
    ...mapGetters("tour", ["getOpenHouseEnabled", "getOpenHouseDays"]),
  },
  methods: {
    expand() {
      this.expanded = true;
    },
    collapse() {
      this.expanded = false;
    },
    prev() {
      this.activeDayIndex -= 1;
    },
    next() {
      this.activeDayIndex += 1;
    },
  },
};
</script>

<style lang="scss">
  .hmt-open-house {
    position: fixed;
    right: 10px;
    top: 95px;
    z-index: 9999;
    width: 170px;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    transition: transform .3s ease-out;
    transform: translateX(150px);

    &--expanded {
      transform: translateX(0);
    }

    &__days {
      text-align: center;
    }

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      background-color: rgb(198, 83, 83);
      color: #fff;
      font-size: 16px;
      font-weight: 600;

      &-btn {
        display: inline-block;
        padding: 0 5px;
        background: transparent;
        border: none;
        cursor: pointer;
        color: #fff;
        font-size: 22px;
        line-height: 1;

        &--hide {
          visibility: hidden;
          pointer-events: none;
        }
      }
    }

    &__body {
      padding: 8px;
      background-color: #fff;
    }

    &__time {
      white-space: nowrap;
    }

    &__date {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: 500;
    }

    &__footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 10px;
      padding: 8px 8px 12px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      background-color: #fff;
    }

    &__paginate-btn {
      display: inline-block;
      padding: 0;
      background: transparent;
      border: none;
      cursor: pointer;
      text-transform: lowercase;
      color: rgb(167, 88, 88);
    }
  }
</style>
